import { RootState } from "app.store";
import * as React from "react";
import "./loading.less";
import clsx from 'clsx';
import { useAppSelector } from "app.hook";
export function Loading(props: any) {
  const isLoading = useAppSelector(
    (state: RootState) => state.globalValue.isLoading
  );
  return (
    <div className={clsx(isLoading &&`Backdrop`)}>
      <div className={`Loader`}>
        <div className="Loader-inner">
         {props.children}
        </div>
      </div>
    </div>
  );
}
